import usePrivateAxios from '@/common/api/usePrivateAxios';
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

type UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses = (workflowId: string | undefined) => UseQueryResult<MaintenanceForwardingsDirectiveEntryKlass[], unknown>;

export const useMaintenanceWorkflowForwardingsDirectiveEntryKlasses: UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses = (workflowiId) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenanceForwardingsDirectiveEntryKlass[] } }, unknown, MaintenanceForwardingsDirectiveEntryKlass[]>({
    enabled: !!workflowiId,
    queryKey: ['maintenanceWorkflowForwardingsDirectiveEntryKlasses', workflowiId],
    queryFn: () => privateAxios.get(`/maintenance/workflows/${workflowiId}/forwardings_directive_entry_klasses`),
    select: (data) => data?.data?.data,
  });
}
